import { Button, Card, Col, Container, Row } from "react-bootstrap";
import TowingCar from "../Images/towingCar.svg";
import CharlesSkinner from "../Images/CharlesSkinner.png";
import InaLeRoux from "../Images/InaLeRoux.jpeg";
import Home from "../Images/home.png";
import Pharmacist from "../Images/PharmacistPills.jpg";
import CommercialBusiness from "../Images/CommercialBusinessInsurance.png";
import Avatar from "../Images/avatar.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBriefcase, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import "./Navbar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./MedicalMalpractice.css";
import PharmacistHeader from "../Images/DoctorCrossedArms.jpg";
import ReactGA from "react-ga4";
import { Briefcase, CheckCircle, ExclamationTriangle, ShieldLock } from "react-bootstrap-icons";


export const MedicalMalpractice = () => {
    ReactGA.initialize("G-ECGH6LJ63Y");
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    return (
        <>
            <Container
                fluid
                style={{
                    background: 'linear-gradient(135deg, #1e1e3f 0%, #3a275e 50%, #ffcc00 100%)',
                    color: '#ffffff',
                    padding: '4rem 2rem',
                    position: 'relative',
                    textAlign: 'center',
                    overflow: 'hidden',
                }}
            >
                {/* Optional Overlay for a polished effect */}
                <div
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 1,
                    }}
                />

                {/* Header Content */}
                <div style={{ position: 'relative', zIndex: 2 }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: '700', marginBottom: '1rem' }}>
                        Medical Malpractice
                    </h1>
                    <p style={{ fontSize: '1.25rem', maxWidth: '700px', margin: '0 auto', color: '#f0f0f0' }}>
                        Protection for healthcare professionals against legal claims.
                    </p>
                </div>
            </Container>
            <br />
            <Container>

                {/* Who We Cover Section */}
                <Container className="my-5 text-center">
                    <h3 style={{ fontSize: '2rem', color: '#1e1e3f', marginBottom: '2rem' }}>
                        Who We Cover
                    </h3>
                    <Row className="justify-content-center">
                        {['Pharmacists/Nurses', 'Healthcare Institutions', 'Doctors'].map((role, idx) => (
                            <Col key={idx} xs={12} md={6} lg={4} className="mb-4 d-flex justify-content-center">
                                <div
                                    style={{
                                        backgroundColor: '#1e1e3f',
                                        color: '#ffffff',
                                        borderRadius: '12px',
                                        padding: '2rem',
                                        width: '100%',
                                        maxWidth: '320px',
                                        boxShadow: '0 6px 18px rgba(0, 0, 0, 0.15)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '1rem',
                                        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.2)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 6px 18px rgba(0, 0, 0, 0.15)';
                                    }}
                                >
                                    <CheckCircle size={28} color="#ffcc00" />
                                    <span style={{ fontSize: '1.2rem', fontWeight: '500' }}>{role}</span>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>

                {/* Brokers Section */}
                <Container className="d-flex justify-content-center">
                    <Row className="justify-content-center w-100" style={{ gap: '2rem' }}>
                        {[{
                            name: "Charles Skinner",
                            phone: "082 338 3950",
                            email: "info@logosbrokers.co.za",
                            image: CharlesSkinner,
                            whatsapp: "738784875",
                            extra: ""
                        },
                        {
                            name: "Ina le Roux",
                            phone: "071 182 8492",
                            email: "admin@logosbrokers.co.za",
                            image: InaLeRoux,
                            whatsapp: "27711828492",
                            extra: ""
                        }].map((broker, idx) => (
                            <Col xs={12} md={6} lg={5} key={idx}>
                                <Card
                                    style={{
                                        borderRadius: '15px',
                                        boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.15)',
                                        padding: '2rem',
                                        textAlign: 'center',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        minHeight: '400px' // Ensures equal height
                                    }}
                                >
                                    <Card.Body>
                                        <div
                                            style={{
                                                width: '100px',
                                                height: '100px',
                                                borderRadius: '50%',
                                                overflow: 'hidden',
                                                margin: '0 auto',
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                            }}
                                        >
                                            <img
                                                src={broker.image}
                                                alt={broker.name}
                                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                            />
                                        </div>
                                        <h3 style={{ fontSize: '1.5rem', margin: '1rem 0 0.5rem 0', fontWeight: 600 }}>
                                            {broker.name}
                                        </h3>
                                        {broker.extra && (
                                            <p style={{ fontSize: '1rem', color: '#555' }}>
                                                {broker.extra}
                                            </p>
                                        )}
                                        <p style={{ fontSize: '1rem', color: '#1e1e3f' }}>
                                            <FontAwesomeIcon icon={faPhone} /> {broker.phone} <br />
                                            <FontAwesomeIcon icon={faEnvelope} /> {broker.email}
                                        </p>
                                        <Button
                                            variant="primary"
                                            href={`https://wa.me/${broker.whatsapp}`}
                                            style={{ marginTop: '1rem' }}
                                        >
                                            Message on WhatsApp
                                        </Button>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>

                <Container className="my-5">
                    <Row className="justify-content-center">
                        <Col lg={10}>
                            <div
                                style={{
                                    backgroundColor: '#1e1e3f',
                                    color: '#ffffff',
                                    padding: '3rem 2rem',
                                    borderRadius: '20px',
                                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                                }}
                            >
                                <h2 style={{ fontSize: '2rem', fontWeight: '600', marginBottom: '2rem', textAlign: 'center' }}>
                                    Why You Need Cover as a Medical Professional
                                </h2>
                                <Row className="text-center">
                                    <Col md={4} className="mb-4">
                                        <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                            <ExclamationTriangle />
                                        </div>
                                        <h5 style={{ fontSize: '1.25rem', fontWeight: '500' }}>Unforeseen Claims</h5>
                                        <p>
                                            Even the most experienced professionals can face claims of negligence. Insurance shields your reputation and finances.
                                        </p>
                                    </Col>
                                    <Col md={4} className="mb-4">
                                        <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                            <ShieldLock />
                                        </div>
                                        <h5 style={{ fontSize: '1.25rem', fontWeight: '500' }}>Legal Protection</h5>
                                        <p>
                                            Get full legal support and defense costs covered if a claim is made against you — whether valid or not.
                                        </p>
                                    </Col>
                                    <Col md={4} className="mb-4">
                                        <div style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#ffcc00' }}>
                                            <Briefcase />
                                        </div>
                                        <h5 style={{ fontSize: '1.25rem', fontWeight: '500' }}>Peace of Mind</h5>
                                        <p>
                                            Focus on your patients knowing that you’re covered. We handle the risks so you can handle the care.
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
                {/* Medical Malpractice Section */}
                <Row className="align-items-center mb-5" style={{ backgroundColor: '#ffffff', padding: '2rem', borderRadius: '10px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)' }}>
                    <Col md={6} className="text-center">
                        <img src={Pharmacist} alt="Pharmacist Malpractice Insurance" style={{ width: '80%', height: 'auto' }} />
                    </Col>
                    <Col md={6}>
                        <h2 style={{ fontSize: '2rem', color: '#1e1e3f' }}>Medical Malpractice Insurance</h2>
                        <p style={{ fontSize: '1.1rem', color: '#333' }}>
                            Protect your professional practice with tailored malpractice insurance as a docter, pharmacist, pharmacist assitant or any health care practitioner. Our coverage ensures you are safeguarded against claims arising from errors, omissions, or negligence.
                        </p>
                    </Col>
                </Row>




            </Container>
            <br />
        </>
    )
}
